import React from "react";
import { graphql } from "gatsby";
import {
  Box,
  Container,
  Hidden,
  styled,
  Typography,
  useTheme
} from "@material-ui/core";
import { formatMultilinesText } from "../../helpers/markdown";

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  "& strong": {
    fontWeight: 500
  }
}));

export default function PartnersQuote({
  title
}: Queries.PartnersQuoteFragmentFragment) {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      bgcolor="primary.main"
      paddingY={{ xs: 25, md: 20 }}
    >
      <Container maxWidth="lg">
        <CustomTypography
          variant="h4"
          dangerouslySetInnerHTML={{ __html: formatMultilinesText(title) }}
        />
      </Container>
    </Box>
  );
}

export const PartnersFlipcardFragment = graphql`
  fragment PartnersQuoteFragment on DatoCmsCModulePartnersQuote {
    title
    container
    containerDisableGutters
    model {
      apiKey
    }
  }
`;
